export default __webpack_public_path__ + "static/media/promo1.6f2162d9.webp";